<template>
  <div>
    <!-- {{file.originalName}} -->
    <b-table
      hover
      small
      head-variant="dark"
      :items="orderedMetas"
      :fields="'#|known_entity|column'.split('|')">
      <template v-slot:cell(#)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(known_entity)="data">
        {{ data.item.description }}
        <i class="text-danger" v-if="data.item.required">*</i>
      </template>
      <template v-slot:cell(column)="data">
        <b-form-select
          size="sm"
          :required="!!data.item.required"
          v-model="map[data.item.name]">
          <template slot="first">
            <option :value="null">--Please select column--</option>
          </template>
          <option
            v-for="col in orderedColumns"
            :key="col.slug"
            :value="col.slug">
            {{ col.name }}
          </option>
        </b-form-select>
      </template>
    </b-table>

    <div class="mt-4 text-right">
      <b-button
        v-if="supportNext && !isDirty && hasAllRequired"
        variant="primary"
        class="px-5"
        @click="onSuccess">
        Next
      </b-button>

      <b-button
        v-else
        variant="primary"
        class="px-5"
        @click="saveMapChanges"
        :disabled="isSaving">
        <i class="fa fa-spin fa-spinner mr-2" v-if="isSaving"/>
        <span>Save&nbsp;</span>
        <span v-if="supportNext">& Continue</span>
        <span v-else>Changes</span>
      </b-button>
    </div>
  </div>
</template>

<script>
  import {saveFileEntityMapChange, saveProjectFileEntityMapChange} from '../../store/files';
  import {hasAllRequiredEntities} from '../../utils';

  export default {
    name: 'ColumnMap',
    props: {
      meta: Object,
      file: Object,
      project: Object,
      supportNext: Boolean
    },
    data() {
      const {entities, type} = this.meta;
      // const file = this.$store.getters.getActiveFile(type);

      return {
        // file,
        isSaving: false,
        isDirty: false,
        // map: entities.reduce((m, {name}) => ({
        //   ...m,
        //   [name]: file.fieldMap[name] || null
        // }), {})
      };
    },

    watch: {
      map: {
        deep: true,
        handler() {
          this.isDirty = true;
        }
      }
    },

    computed: {
      orderedMetas() {
        return this.meta.entities;
      },

      orderedColumns() {
        return this.file.columns.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // ignore upper and lowercase
          const nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      },

      hasAllRequired() {
        return hasAllRequiredEntities(this.meta.entities, this.map);
      },

      missingError() {
        return 'All required* mappings must be specified';
      },

      map() {
        console.log("Project FieldMap: ", this.project.fieldMap);
        var fieldMap = {};
        var fieldMapKeys = Object.keys(this.project.fieldMap);
        if (!!this.project && !!this.project.fieldMap) { 
          fieldMap = this.project.fieldMap;
        }
        return this.meta.entities.reduce((m, {name}) => ({
          ...m,
          [name]: (fieldMapKeys.indexOf(this.file.id) > -1) ? fieldMap[this.file.id][name] : null
        }), {});
      }
    },

    methods: {
      onSuccess() {
        this.$emit('success');
      },

      saveMapChanges() {
        const {id: fileID} = this.file;
        const {id: projectID} = this.project;
        var fieldMap = this.project['fieldMap'];

        if (!this.hasAllRequired) {
          this.$toasted.error(this.missingError, {
            position: 'bottom-center',
            duration: 3000,
            theme: 'bubble',
            iconPack: 'fontawesome',
            icon: 'times'
          });
          return;
        }

        const mapWithNulls = this.map;
        const mapWithoutNulls = Object.keys(mapWithNulls).reduce(
          (cleanMap, key) => mapWithNulls[key] ? {...cleanMap, [key]: mapWithNulls[key]} : cleanMap, {});

        this.isSaving = true;
        fieldMap[fileID] = mapWithoutNulls;
        this.$store.dispatch(saveProjectFileEntityMapChange(projectID, fieldMap))
          .then(() => {
            this.isDirty = false;
            this.onSuccess();
          })
          .catch(console.log)
          .finally(() => {this.isSaving = false;});
        
        this.$store.dispatch(saveFileEntityMapChange(fileID, mapWithoutNulls))
          .then(() => {
            this.isDirty = false;
            this.onSuccess();
          })
          .catch(console.log)
          .finally(() => {this.isSaving = false;});
      },
    }

  };
</script>

<style scoped>

</style>
